module.exports = __webpack_public_path__ + "static/img/home_map.5bd4237.png";


//////////////////
// WEBPACK FOOTER
// ./static/mobile/index/home_map.png
// module id = I5i5
// module chunks = 0